<template>
    <kgr-generic-select
        v-model="selection"
        :options="options"
        display="value"
        @post-input="update()"
    />
</template>

<script>
import GenericSelect from './GenericSelect.vue';

export default {
    components: {
        'kgr-generic-select': GenericSelect,
    },
    props: {
        gender: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            selection: null,
        };
    },
    computed: {
        options() {
            const gender = (this.gender === null || this.gender === '') ? 'gender.u' : this.gender;

            return [
                { key: 'spouseOf', value: this.$t(`relation.spouseOf.${gender}`) },
                { key: 'parentOf', value: this.$t(`relation.parentOf.${gender}`) },
                { key: 'childOf', value: this.$t(`relation.childOf.${gender}`) },
                { key: 'siblingOf', value: this.$t(`relation.siblingOf.${gender}`) },
                { key: 'familyOf', value: this.$t('relation.familyMember') },
            ];
        },
    },
    methods: {
        update() {
            const key = this.selection ? this.selection.key : null;
            this.$emit('input', key);
            this.$nextTick(() => {
                this.$emit('post-input', key);
            });
        },
    },
};
</script>
